import { GetStaticProps } from "next"
import Image from "next/image"
import { Box, Container, Grid } from "@mui/material"

import BreadCrumbs, { BreadCrumbAncestor } from "components/BreadCrumbs"

import useTranslation from "hooks/useTranslation"

import { getServerTranslations } from "utils/i18n/getServerTranslations"
import { helpCenterBreadCrumb } from "./index"

const Security = () => {
	const { t } = useTranslation("help")

	const breadCrumb: BreadCrumbAncestor = {
		label: t("security"),
		href: "/help/security",
	}

	return (
		<Box my={5} pb={5}>
			<Box style={{ marginTop: "-40px", paddingBottom: "20px" }}>
				<BreadCrumbs
					breadCrumbsPaths={[
						{ ...helpCenterBreadCrumb, label: t(helpCenterBreadCrumb.label) },
					]}
					currentPath={breadCrumb}
				/>
			</Box>
			<Container>
				<Box pb={5} style={{ textAlign: "center", maxWidth: "750px", margin: "auto" }}>
					<h1>{t("securityBeginsOnline")}</h1>
					<p style={{ color: "grey" }}>{t("securityBeginsOnlineText")}</p>
				</Box>
				<Grid container spacing={3}>
					<Grid item xs={12} md={6}>
						<Box
							mt={5}
							pt={5}
							style={{
								borderBottom: "1px solid lightgrey",
								paddingBottom: "5px",
							}}
							className="h2"
						>
							<span style={{ borderBottom: "6px solid #7abfac", fontSize: "20px" }}>
								{t("onlineSecurity")}
							</span>
						</Box>
						<p>{t("onlineSecurityText")}</p>
					</Grid>
					<Grid item xs={12} md={6}>
						<div
							style={{
								maxWidth: "400px",
								width: "100%",
								margin: "auto",
								textAlign: "center",
							}}
						>
							<Image
								alt="security"
								src="https://res.cloudinary.com/safehero/image/upload/v1572511007/HelpCenter/website-security.png"
								width={400}
								height={400}
								style={{
									maxWidth: "100%",
									maxHeight: "400px",
									height: "auto",
									objectFit: "contain",
								}}
							/>
						</div>
					</Grid>
				</Grid>
			</Container>
		</Box>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	const props = {
		...(await getServerTranslations(context.locale, [
			"common",
			"countries",
			"languages",
			"help",
		])),
	}

	return {
		props,
	}
}

export default Security
